var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SettableKeys } from '../lib/keys';
import { buttonStyles } from './button';
export const touchKeys = new SettableKeys();
let TouchControls = class TouchControls extends LitElement {
    constructor() {
        super(...arguments);
        this.boundHandleTouchChange = this.handleTouchChange.bind(this);
    }
    render() {
        return html `
            <img class="touch-pad" src="sprites/control.png" draggable="false"
                @touchstart="${this.handleTouchChange}"
                @touchend="${this.handleTouchChange}"
                @touchmove="${this.handleTouchChange}"
                @touchcancel="${this.handleTouchChange}"
            ></img>
            <button
                class="restart-button button"
                @click="${this.handleRestart}">Restart</button>
        `;
    }
    handleRestart() {
        this.dispatchEvent(new CustomEvent('restart'));
        // Remove focus from the button
        this.blur();
    }
    handleTouchChange(event) {
        console.log(event.currentTarget);
        const elem = this.shadowRoot.querySelector('.touch-pad');
        if (event.currentTarget !== this && event.currentTarget !== elem) {
            return;
        }
        event.preventDefault();
        const rect = elem.getBoundingClientRect();
        const midX = rect.left + rect.width / 2;
        const midY = rect.top + rect.height / 2;
        const touch = event.touches[0];
        const touchX = touch ? touch.clientX - midX : 0;
        const touchY = touch ? touch.clientY - midY : 0;
        const threshold = rect.width * 0.1;
        if (touchX < -threshold) {
            touchKeys.setKey('TouchLeft', true);
            touchKeys.setKey('TouchRight', false);
        }
        else if (touchX > threshold) {
            touchKeys.setKey('TouchLeft', false);
            touchKeys.setKey('TouchRight', true);
        }
        else {
            touchKeys.setKey('TouchLeft', false);
            touchKeys.setKey('TouchRight', false);
        }
        if (touchY < -threshold) {
            touchKeys.setKey('TouchUp', true);
            touchKeys.setKey('TouchDown', false);
        }
        else if (touchY > threshold) {
            touchKeys.setKey('TouchUp', false);
            touchKeys.setKey('TouchDown', true);
        }
        else {
            touchKeys.setKey('TouchUp', false);
            touchKeys.setKey('TouchDown', false);
        }
    }
};
TouchControls.styles = [
    buttonStyles,
    css `
        :host {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }

        .touch-pad {
            position: absolute;
            width: 50vmin;
            height: 50vmin;
            width: 200px;
            height: 200px;
            left: -8vmin;
            bottom: -8vmin;
            image-rendering: pixelated;
            opacity: 0.5;
            padding: 12vmin;
        }

        .restart-button {
            position: absolute;
            top: 0;
            right: 0;
            margin: 4vmin;
            opacity: 0.5;
        }
    `
];
TouchControls = __decorate([
    customElement('touch-controls')
], TouchControls);
export { TouchControls };
